/* eslint-disable */
export const FILTER_STATUS_SELECTED = `[FILTER] STATUS SELECTED`;
export const FILTER_NUMBER_OF_DAYS_SELECTED = `[FILTER] NUMBER OF DAYS SELECTED`;
export const FILTER_START_DATE_SELECTED = `[FILTER] START DATE SELECTED`;
export const FILTER_TODAY_DATE_SELECTED = `[FILTER] TODAY DATE SELECTED`;
export const FILTER_NEXT_DATE_RANGE_SELECTED = `[FILTER] NEXT DATE RANGE SELECTED`;
export const FILTER_PREV_DATE_RANGE_SELECTED = `[FILTER] PREV DATE RANGE SELECTED`;

export const FILTER_ADDRESS_ADDED = `[FILTER] ADDRESS ADDED`;
export const FILTER_ADDRESS_REMOVED = `[FILTER] ADDRESS REMOVED`;
export const FILTER_ADDRESS_SELECTED = `[FILTER] ADDRESS SELECTED`;
export const FILTER_ADDRESS_UNSELECTED = `[FILTER] ADDRESS UNSELECTED`;
export const FILTER_ADDRESS_TOGGLED_ALL = `[FILTER] ADDRESS TOGGLED ALL`;
export const FILTER_ADDRESS_REMOVED_ALL = `[FILTER] ADDRESS REMOVED ALL`;

export const FILTER_ACCOUNT_SELECTED = `[FILTER] ACCOUNT SELECTED`;

export const FILTER_PROJECT_SELECTED = `[FILTER] PROJECT SELECTED`;
